import React, { useEffect, useState } from 'react';
import { ShieldCheck, Clock, CreditCard, AlertTriangle } from 'lucide-react';
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('countdown_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    // 2 hours in seconds
    const end = Date.now() + 2 * 60 * 60 * 1000;
    sessionStorage.setItem('countdown_end', end.toString());
    return 2 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-3 my-8" data-id="element-32">
      <div className="flex items-center gap-1" data-id="element-33">
        <AlertTriangle className="w-5 h-5 text-red-400 mr-2" data-id="element-34" />
        <span className="text-red-400 font-bold text-sm uppercase tracking-wider" data-id="element-35">
          Esta oferta expira en:
        </span>
      </div>
      <div className="flex gap-2" data-id="element-36">
        <div className="bg-red-600 text-white font-black text-2xl md:text-3xl px-3 py-2 rounded-lg min-w-[60px] text-center" data-id="element-37">
          {pad(hours)}
          <span className="block text-[10px] font-normal uppercase tracking-wider" data-id="element-38">
            Hrs
          </span>
        </div>
        <span className="text-red-400 font-black text-2xl md:text-3xl self-start mt-2" data-id="element-39">
          :
        </span>
        <div className="bg-red-600 text-white font-black text-2xl md:text-3xl px-3 py-2 rounded-lg min-w-[60px] text-center" data-id="element-40">
          {pad(minutes)}
          <span className="block text-[10px] font-normal uppercase tracking-wider" data-id="element-41">
            Min
          </span>
        </div>
        <span className="text-red-400 font-black text-2xl md:text-3xl self-start mt-2" data-id="element-42">
          :
        </span>
        <div className="bg-red-600 text-white font-black text-2xl md:text-3xl px-3 py-2 rounded-lg min-w-[60px] text-center" data-id="element-43">
          {pad(seconds)}
          <span className="block text-[10px] font-normal uppercase tracking-wider" data-id="element-44">
            Seg
          </span>
        </div>
      </div>
    </div>;
}
export function PurchaseSection() {
  return <section id="compra" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/60 border-t border-slate-800/50" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-48">
            Redacción de Puntos Periciales{' '}
            <span className="text-gold-500 block mt-2" data-id="element-49">PRO</span>
          </h2>
          <p className="text-2xl text-slate-300 font-serif italic" data-id="element-50">
            Dejá de improvisar tus escritos. Empezá a trabajar con estructura.
          </p>
        </div>

        <div className="bg-slate-800/90 rounded-3xl border-2 border-gold-500/50 p-8 md:p-12 shadow-[0_0_50px_rgba(245,158,11,0.15)] relative overflow-hidden" data-id="element-51">
          <div className="absolute top-0 right-0 bg-red-600 text-white text-sm font-bold px-10 py-2 transform translate-x-8 translate-y-6 rotate-45 shadow-lg" data-id="element-52">
            OFERTA HOY
          </div>

          <CountdownTimer data-id="element-53" />

          <div className="text-center mb-10" data-id="element-54">
            <p className="text-slate-400 mb-2 text-lg" data-id="element-55">Precio Regular:</p>
            <p className="text-3xl text-slate-500 line-through font-bold mb-6" data-id="element-56">
              $49.990
            </p>
            <p className="text-base text-gold-400 font-bold uppercase tracking-widest mb-2" data-id="element-57">
              Precio Único Promocional
            </p>
            <div className="flex justify-center items-start" data-id="element-58">
              <span className="text-4xl font-bold text-white mt-2" data-id="element-59">$</span>
              <span className="text-7xl md:text-8xl font-black text-white tracking-tight" data-id="element-60">
                19.990
              </span>
              <span className="text-2xl text-slate-400 mt-10 ml-2" data-id="element-61">ARS</span>
            </div>
          </div>

          <div className="space-y-5 mb-12 max-w-md mx-auto bg-slate-900/50 p-6 rounded-2xl border border-slate-700" data-id="element-62">
            <div className="flex items-center text-slate-200" data-id="element-63">
              <ShieldCheck className="w-6 h-6 text-green-400 mr-4 flex-shrink-0" data-id="element-64" />
              <span className="text-lg" data-id="element-65">Acceso inmediato y de por vida</span>
            </div>
            <div className="flex items-center text-slate-200" data-id="element-66">
              <Clock className="w-6 h-6 text-green-400 mr-4 flex-shrink-0" data-id="element-67" />
              <span className="text-lg" data-id="element-68">Incluye todos los bonos gratuitos</span>
            </div>
            <div className="flex items-center text-slate-200" data-id="element-69">
              <CreditCard className="w-6 h-6 text-green-400 mr-4 flex-shrink-0" data-id="element-70" />
              <span className="text-lg" data-id="element-71">Pago seguro en pesos argentinos</span>
            </div>
          </div>

          <div className="text-center" data-id="element-72">
            <a href="https://checkout.ebookpoint.shop/cart/59452963192913:1" className="block w-full bg-[#dc2626] hover:bg-[#ef4444] text-white font-black text-xl md:text-2xl py-6 rounded-xl shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:-translate-y-1 mb-4 uppercase tracking-wide border-b-4 border-[#991b1b]" data-id="element-73">
              COMPRAR AHORA POR $19.990
            </a>
            <p className="text-sm text-slate-400 mt-4" data-id="element-74">
              Serás redirigido a la plataforma de pago seguro.
            </p>
          </div>
        </div>

        {/* Objection handler */}
        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-75">
          <p className="text-xl text-slate-200 mb-3 font-serif italic" data-id="element-76">
            "¿Y si no es lo que necesito?"
          </p>
          <p className="text-lg text-slate-300 mb-8" data-id="element-77">
            Este recurso fue diseñado por y para profesionales del derecho que
            trabajan con pericias a diario. No es teoría: son formatos, modelos
            y estructuras que podés usar desde el primer minuto. Si no mejora tu
            forma de redactar, no perdiste nada — pero si lo hace, ganaste horas
            de trabajo y escritos más sólidos.
          </p>
          <a href="https://checkout.ebookpoint.shop/cart/59452963192913:1" className="inline-block w-full md:w-auto bg-[#dc2626] hover:bg-[#ef4444] text-white font-black text-lg px-10 py-4 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:-translate-y-1 uppercase tracking-wide border-b-4 border-[#991b1b]" data-id="element-78">
            SÍ, QUIERO MEJORAR MIS ESCRITOS
          </a>
        </div>
      </div>
    </section>;
}